let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("khT8i")).then(() => parcelRequire('hxhBB'));